import { Controller } from "stimulus";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

export default class extends Controller {
  connect() {
    this.inputs.forEach(input => {
      input.addEventListener("change", this.updateSubmitButton.bind(this));
      input.addEventListener("keyup", this.updateSubmitButton.bind(this));
    });

    this.setState();
  }

  setState() {
    this.currentState = this.getFormState();
    this.updateSubmitButton();
  }

  updateSubmitButton() {
    this.submitButtons.forEach(button => {
      if (this._isTouched()) {
        enableElement(button);
      } else {
        disableElement(button);
      }
    });
  }

  _isTouched() {
    return this.getFormState() !== this.currentState;
  }

  getFormState() {
    return this.inputs.map(input => {
      switch (input.type) {
      case "number":
      case "email":
      case "textarea":
      case "file":
      case "password":
        return input.value;
      case "text":
        if (!input.readOnly) {
          return input.value;
        }
        break;

      case "checkbox":
        if (input.checked && input.dataset.untouchableIgnore !== "true") {
          return input.id;
        }
        break;

      case "select-one":
        if (!input.classList.contains("datepicker-select")) {
          return input.value;
        }
        break;

      case "select-multiple":
        return Array.from(input.selectedOptions).map(option => {
          return option.value;
        }).join("");

      case "hidden":
        if (input.dataset.untouchableTrackChanged === "true") {
          return input.value;
        }
        break;
      default:
        console.error(`Add case for ${input.type} in untouchable_controller#getFormState()`);
        break;
      }
    }).sort().join("");
  }

  get inputs() {
    return [
      ...this.element.querySelectorAll("input"),
      ...this.element.querySelectorAll("select"),
      ...this.element.querySelectorAll("textarea")
    ];
  }

  get submitButtons() {
    return this.element.querySelectorAll("button[type=\"submit\"]");
  }
}
